export default {
 TOOLTIP:'This will be safely stored in Documents, your Clara data room.'
}